export default "__VITE_ASSET__BttSe4Fi__"